import request from '@host-panel/request';

export function setPassword(
  password: string,
  ticket: string,
  networkId: string,
  spotId: string
): Promise<{ token_ticket: string }> {
  return request(`/set-password`, {
    method: 'POST',
    service: 'emailConnect',
    data: {
      password,
      ticket
    },
    headers: {
      'x-spotim-spotid': spotId,
      'x-spotim-networkid': networkId,
      'x-auth-version': '2'
    }
  });
}
